export const To_LIGHT = "To_LIGHT";
export const To_DARK = "To_DARK";